import { usePylon } from 'utils/usePylon'

export const PylonIntegration = () => {
    usePylon()

    return null
}
